import type { PropsWithChildren } from "react";

import { useInputPopoverContext } from "@components/organisms/inputPopover/useInputPopoverContext";
import type { IItemProps } from "@/components/atoms/menuItem";
import { MenuItem } from "@/components/atoms/menuItem";

export function InputMenuItemPopover(
  props: Omit<PropsWithChildren<IItemProps & { index: number }>, "ref">,
) {
  const { index, children, ...rest } = props;

  const { getItemProps, listRef, activeIndex } = useInputPopoverContext();

  return (
    <MenuItem
      {...getItemProps({
        ref(node) {
          listRef.current[index] = node;
        },
      })}
      active={activeIndex === index}
      {...rest}
    >
      {children}
    </MenuItem>
  );
}
